class ThemeManager {
    constructor() {
        this.storageKey = 'jigsai-theme'
        this.themes = {
            LIGHT: 'light',
            DARK: 'dark'
        }
    }

    /**
     * Initialize theme based on system preference
     */
    initializeTheme() {
        const systemPreference = this.getSystemPreference()
        this.setTheme(systemPreference)
    }

    /**
     * Get stored theme preference from localStorage
     * @returns {string|null} - The stored theme or null if not found
     */
    getStoredTheme() {
        try {
            return localStorage.getItem(this.storageKey)
        } catch (error) {
            console.warn('Could not access localStorage:', error)
            return null
        }
    }

    /**
     * Get system theme preference
     * @returns {string} - 'dark' or 'light'
     */
    getSystemPreference() {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return this.themes.DARK
        }
        return this.themes.LIGHT
    }

    /**
     * Set theme (follows system preference automatically)
     * @param {string} theme - 'dark' or 'light'
     */
    setTheme(theme) {
        if (!Object.values(this.themes).includes(theme)) {
            console.warn(`Invalid theme: ${theme}`)
            return
        }

        // Update document class
        const htmlElement = document.documentElement
        if (theme === this.themes.DARK) {
            htmlElement.classList.add('dark')
        } else {
            htmlElement.classList.remove('dark')
        }

        // Dispatch custom event for components to listen to
        window.dispatchEvent(new CustomEvent('theme-changed', {
            detail: { theme }
        }))
    }

    /**
     * Toggle between light and dark themes (temporarily)
     * This will be overridden by system changes
     */
    toggleTheme() {
        const currentTheme = this.getCurrentTheme()
        const newTheme = currentTheme === this.themes.DARK ? this.themes.LIGHT : this.themes.DARK
        this.setTheme(newTheme)
    }

    /**
     * Get current theme
     * @returns {string} - Current theme ('dark' or 'light')
     */
    getCurrentTheme() {
        return document.documentElement.classList.contains('dark') ? this.themes.DARK : this.themes.LIGHT
    }

    /**
     * Update theme based on system preference
     */
    updateFromSystem() {
        const systemPreference = this.getSystemPreference()
        this.setTheme(systemPreference)
    }
}

// Create global instance
window.themeManager = new ThemeManager()

export default window.themeManager